'use client';

import { simpleCardsListSection } from '@stereoagency/sanity-schema';
import { SimpleCardRowsSection } from '@stereoagency/ui';
import flush from 'just-flush';
import { SimpleBlockContent } from '../sanity/client';
import { actionAsProps } from '@/utils';

type Props = typeof simpleCardsListSection.schema.simpleCardsListSection;

export default function SimpleCardsListSection({
  title,
  description,
  rows,
  actions
}: Props) {
  if (!rows?.length) {
    return null;
  }

  return (
    <SimpleCardRowsSection
      title={title}
      description={
        description ? <SimpleBlockContent value={description} /> : null
      }
      rows={flush(rows.map((row) => {
        if (!row.title) {
          return null;
        }

        return {
          title: row.title,
          description: row.description ? (
            <SimpleBlockContent value={row.description} />
          ) : null
        };
      }))}
      actions={flush(
        actions?.map((action) => {
          if (!action.action || !action.label) {
            return null;
          }

          return {
            label: action.label,
            action: actionAsProps(action.action)
          };
        }) ?? []
      )}
    />
  );
}
